import React from "react";

/** Compact diagrams stay recognizable at both navigator and chooser sizes. */
export default function ModelTypeIcon({ type, size = 24, className = "" }: {
  type: string; size?: number; className?: string;
}) {
  const physical = type === "physical" || type === "logical-physical";
  const table = (x: number, y: number, width: number, rows: number, key: string) => (
    <g key={key}>
      <rect x={x} y={y} width={width} height={11 + rows * 5} rx="2" fill="currentColor" fillOpacity=".08" />
      <rect x={x} y={y} width={width} height={7} rx="2" fill="currentColor" fillOpacity=".25" stroke="none" />
      {Array.from({ length: rows }, (_, i) => <path key={i} d={`M${x + 3} ${y + 11 + i * 5}h${width - 6}`} opacity=".65" />)}
    </g>
  );
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={`model-type-miniature ${className}`} aria-hidden="true">
    {type === "conceptual" ? <>
      <path d="M28 21h8v23h3" />
      {table(2, 7, 27, 2, "a")}{table(36, 33, 26, 2, "b")}
    </> : type === "entity" ? <>{table(13, 7, 38, 7, "entity")}</> : type === "group" ? <>
      <rect x="3" y="5" width="58" height="54" rx="5" strokeDasharray="3 3" opacity=".6" />
      {table(10, 14, 18, 3, "a")}{table(37, 27, 17, 3, "b")}<path d="M28 27h5v12h4" />
    </> : <>
      <path d={physical ? "M24 19h11M16 30v16h17M44 29v10" : "M24 19h14M15 28v12M48 29v11M25 51h11"} />
      {table(3, 6, 22, type === "logical-physical" ? 5 : 3, "a")}
      {table(37, 10, 23, 3, "b")}
      {!physical && <>{table(3, 39, 22, 2, "c")}{table(37, 40, 23, 2, "d")}</>}
      {physical && <g>
        <path d="M35 43v13c0 6 25 6 25 0V43" fill="currentColor" fillOpacity=".08" />
        <ellipse cx="47.5" cy="43" rx="12.5" ry="5" fill="currentColor" fillOpacity=".2" />
        <path d="M35 49c0 6 25 6 25 0" />
      </g>}
      {type === "logical-physical" && <path d="M7 51h17m-4-4 4 4-4 4" strokeWidth="2.6" />}
    </>}
  </svg>;
}
